import {isBrowser} from '@vio/core/src/_web/utils/environment'
import {urlParamsParser} from '@vio/core/src/_web/utils/url/urlParamsParser'
import {UrlCheckoutParamsType} from '@vio/core/src/utils/url/types/UrlParams'

export const parseUrlParams = (search: string) =>
  urlParamsParser(search) as UrlCheckoutParamsType

export const getSearchFromPath = (path: string) =>
  new URL(path, 'https://vio.com').searchParams.toString()

// Empty during SSR. Render code should use `getUrlParams` or `useParams`
export const urlParams = () => parseUrlParams(isBrowser ? location.search : '')
